export default {
	setListOfDeals(state, data) {
		state.listOfDeals = data;
	},
};
